import { defineStore } from 'pinia';
import { LightTheme } from '@/theme/LightTheme';
import { DarkTheme } from '@/theme/DarkTheme';

export const useThemeStore = defineStore('theme', {
  state: () => ({
    isDark: false,
    theme: LightTheme.name
  }),

  persist: true,

  getters: {},
  actions: {
    toggleTheme() {
      this.isDark = !this.isDark;

      if (this.isDark) {
        this.theme = DarkTheme.name;
      } else {
        this.theme = LightTheme.name;
      }
    },

    setTheme(theme: string) {
      this.isDark = DarkTheme.name === theme;
      this.theme = theme;
    }
  }
});
